import { Feature } from 'types/domain'
import useAccountSubscriptionCache from 'components/business/hooks/useAccountSubscriptionCache'

export default function useCampaignsQuota() {
  const { subscription } = useAccountSubscriptionCache()
  const vas = subscription?.product?.vas ?? []
  return vas.find(({ type }) => type === Feature.CampaignsCountPerApplication)?.quota ?? 0
}
